export class ForbiddenError extends Error {
  constructor(message = '403', redirectURL, popUp) {
    super(message)
    this.name = 'forbiddenError'
    this.status = 403
    this.redirectURL = redirectURL
    this.popUp = popUp
    this.report = false
  }
}
